import { useEffect } from 'react';
import { gsap, ScrollTrigger } from '../hooks/gsap-init';

export const useScrollAnimations = () => {
    useEffect(() => {
        const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;

        if (prefersReducedMotion) return;

        // Fade Up Animation
        const fadeUpElements = document.querySelectorAll('[data-animate="fade-up"]');
        fadeUpElements.forEach((el) => {
            gsap.fromTo(
                el,
                {
                    opacity: 0,
                    y: 60,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 85%',
                        toggleActions: 'play none none none',
                    },
                }
            );
        });

        // Stagger Children Animation
        const staggerContainers = document.querySelectorAll(
            '[data-animate="stagger-children"]'
        );
        staggerContainers.forEach((container) => {
            const children = container.children;
            gsap.fromTo(
                children,
                {
                    opacity: 0,
                    y: 40,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.15,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: container,
                        start: 'top 80%',
                        toggleActions: 'play none none none',
                    },
                }
            );
        });

        return () => {
            ScrollTrigger.getAll().forEach((t) => t.kill());
        };
    }, []);
};
